import { render, staticRenderFns } from "./LicenciasModifica.vue?vue&type=template&id=f9916d50&"
import script from "./LicenciasModifica.vue?vue&type=script&lang=js&"
export * from "./LicenciasModifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports